<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17DpvGG/Images/cover.jpeg?1708093843880" alt="This image is the cover for the book The Fellowship of the Frog, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Fellowship of the Frog, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>The Fellowship of the Frog is a 1925 crime novel by the British writer Edgar Wallace. It was part of a series of books featuring the character Inspector Elk of Scotland Yard. In 1936 it was adapted into a West End play The Frog by Ian Hay, which inspired the subsequent films.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edgar Wallace
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aba39cfa